import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { api } from '../lib/api';
import { ScreenHeader } from '../components/ScreenHeader';

interface Entry {
  id: string;
  date: string;
  body: string;
  createdAt: number;
}

export default function JournalPage() {
  const qc = useQueryClient();
  const [draft, setDraft] = useState('');
  const list = useQuery({
    queryKey: ['journal'],
    queryFn: () => api.get<{ entries: Entry[] }>('/journal'),
  });
  const create = useMutation({
    mutationFn: (body: string) => api.post('/journal', { body }),
    onSuccess: () => {
      setDraft('');
      void qc.invalidateQueries({ queryKey: ['journal'] });
    },
  });

  return (
    <>
      <ScreenHeader
        title="Journal"
        subtitle="Just you and God. Parents don't see this by default."
      />
      <div className="px-5 pt-4 pb-6">
        <form
          onSubmit={(e) => {
            e.preventDefault();
            if (draft.trim()) create.mutate(draft.trim());
          }}
          className="card p-4 mt-5"
        >
          <textarea
            value={draft}
            onChange={(e) => setDraft(e.target.value)}
            rows={5}
            placeholder="What's on your heart?"
            className="w-full bg-transparent text-ink placeholder:text-muted resize-none focus:outline-none"
          />
          <div className="flex justify-end">
            <button
              disabled={!draft.trim() || create.isPending}
              className="h-10 px-5 rounded-full bg-oxblood text-paper text-sm font-medium disabled:opacity-50"
            >
              Save
            </button>
          </div>
        </form>

        <div className="mt-6 space-y-3">
          {list.data?.entries.map((e) => (
            <article key={e.id} className="card p-4">
              <div className="kicker text-muted">
                {new Date(e.date).toLocaleDateString([], {
                  month: 'long',
                  day: 'numeric',
                  year: 'numeric',
                })}
              </div>
              <p className="text-ink mt-2 leading-relaxed whitespace-pre-wrap">
                {e.body}
              </p>
            </article>
          ))}
        </div>
      </div>
    </>
  );
}
